import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getprojectInchargeSummary } from "../../../../store/Api/projectInchargeSummaryAPI";

export default function EmployeeManager({propData,EmployeeData}) {

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
    {
      id: 2,
      name: "YTC",
    },
    {
      id: 3,
      name: "YTC",
    },
  ];
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  console.log("propData....propData",EmployeeData)

  useEffect(() => {
    dispatch(getprojectInchargeSummary(token));
  }, []);

  const projectInchargeSummary = useSelector((state) => state.projectInchargeData);

  console.log("projectInchargeSummary............",projectInchargeSummary)
  return (
    <>
      <div className="!uppercase">
        <p className="ml-8">PROJECT INCHARGE SUMMARY</p>
        <div className="flex flex-col w-full gap-1 my-2 pl-8 pt-2">
          <div className="flex overflow-x-scroll lg:overflow-auto" style={{ height: "200px" }} >
            {row.map((section, sectionIndex) => (
              <div className="flex flex-col relative" key={sectionIndex}>
                {sectionIndex == 0 && (
                  <>
                    <div className={`flex w-full gap-1 `}>
                      <>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          NAME
                        </h3>

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          IMPREST RECEIVED
                        </h3>

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          IMPREST CLEARED
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          BALANCE
                        </h3>
                      </>
                    </div>
                  </>
                )}
                <div className="mb-2">
                  {projectInchargeSummary?.data?.map((data, index) => (
                    <div
                      className="flex w-full gap-1 relative mb-2 mt-2"
                      key={index}
                    >
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data?.project_incharge_name}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data?.total_loan_advance}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                   
                        {/* {parseInt(data?.total_cash_receipt_amount) + parseInt(data?.total_document_receipt_amount)} */}
                        {(data?.total_cash_receipt_amount || 0) + (data?.total_document_receipt_amount || 0)}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {(data.total_loan_advance || 0) - ((data.total_cash_receipt_amount || 0) + (data.total_document_receipt_amount || 0))}
                      </p>
                    </div>
                   ))} 
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
